import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICES_PORTAL_URL } from '../lib/siteUrls';

const PublicNavLinks: React.FC = () => (
  <>
    <Link to="/">Home</Link>
    <a href={SERVICES_PORTAL_URL}>Services</a>
    <Link to="/privacy-policy">Privacy</Link>
  </>
);

export default PublicNavLinks;
